import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const perguntas = [
    {
      pergunta: 'Para quem é este protocolo?',
      resposta:
        'Para familiares e cuidadores que convivem com Alzheimer e enfrentam dificuldades com agitação, resistência ou crises no dia a dia.O protocolo ensina como identificar os gatilhos e evitar essas crises.',
    },
    {
      pergunta: 'Preciso ter conhecimento médico para aplicar?',
      resposta:
        'Não! O protocolo foi desenvolvido especialmente para pessoas sem formação médica. Todas as estratégias são explicadas de forma simples, prática e podem ser aplicadas imediatamente no dia a dia.',
    },
    {
      pergunta: 'Quanto tempo leva para ver resultados?',
      resposta: `Muitas famílias começam a perceber mudanças já nas primeiras semanas, porque passam a identificar os sinais antes das crises e agir de forma diferente.
Quanto mais cedo você aplica as estratégias, maiores são as chances de prevenir os episódios e tornar a rotina mais tranquila.`,
    },
    {
      pergunta: 'O conteúdo fica disponível por quanto tempo?',
      resposta:
        'Você tem acesso vitalício ao conteúdo. Pode assistir quantas vezes quiser, no seu próprio ritmo, e ainda recebe todas as atualizações futuras gratuitamente.',
    },
    {
      pergunta: 'Funciona em qualquer estágio do Alzheimer?',
      resposta:
        'O protocolo é mais eficaz nos estágios leve a moderado, quando a pessoa ainda mantém alguma capacidade de comunicação e interação. Para casos avançados, algumas estratégias podem precisar de adaptação.',
    },
    {
      pergunta: 'E se eu não conseguir aplicar sozinho?',
      resposta:
        'As aulas são simples, objetivas e fáceis de aplicar. Além disso, você recebe PDFs de apoio para consultar sempre que precisar.',
    },
  ];

  const togglePergunta = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-teal-50/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        {/* Título */}
        <h2 className="text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-12">
          Perguntas Frequentes
        </h2>

        {/* Acordeão */}
        <div className="space-y-4">
          {perguntas.map((item, index) => (
            <div
              key={index}
              className="bg-white border border-teal-100 rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              {/* Pergunta */}
              <button
                onClick={() => togglePergunta(index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-teal-50/30 transition-colors duration-200 cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                  {item.pergunta}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-teal-600 text-2xl transition-transform duration-200`}
                  ></i>
                </div>
              </button>

              {/* Resposta */}
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-700 text-base leading-relaxed">{item.resposta}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}